<small *ngIf="displayError">
    {{errorMsg}}<br>
</small>